import { Assignment } from '@/wpt-lib/interfaces/Assignment';

export function isAdminFor(admin?: Assignment, staff?: Assignment): boolean {
    if (!admin || !staff) return false;

    /* Global admin. */
    if (admin.isGlobalAdmin) return true;

    /* Faculty admin of user faculty. */
    if (
        staff.organisation?.faculty?.id &&
        admin.adminFaculties?.map((a) => a.faculty?.id).includes(staff.organisation.faculty.id)
    )
        return true;

    /* Organisation admin for user organisation. */
    if (
        staff.organisation?.id &&
        admin.adminOrganisations?.map((o) => o.organisation?.id).includes(staff.organisation.id)
    )
        return true;

    return false;
}
